export const useCloseModal = () => {
  const closeModal = (modal: HTMLIonModalElement) => {
    setTimeout(() => modal.dismiss(), 200);
  };

  return {
    closeModal,
  };
};
